module.exports = __webpack_public_path__ + "img/fig_4_1.f6a5b309.png";